<template>
  <div class="c-card__body">
    <b-img src="images/layout/illu-new-existing-certificate.png" class="c-card__image" fluid alt="New from Similar Certificate" />
    <h5 class="c-card__headline">{{ $t("lang.label_certificate_new_fromExisting") }}</h5>
    <div class="c-card__indicator">
      <mtg-icon icon="ic-check" viewBox="0 0 20 14"></mtg-icon>
    </div>
  </div>
</template>
<script>
export default {
  name: "WizardButtonFromExisting"
};
</script>
